const siteId = 10021;

export default {
    siteId
}
